/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListMcpApprovalRequestsRequest,
  ListMcpApprovalRequestsSecurity,
} from "../models/operations/listmcpapprovalrequests.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildListMcpApprovalRequestsQuery,
  ListMcpApprovalRequestsQueryData,
  prefetchListMcpApprovalRequests,
  queryKeyListMcpApprovalRequests,
} from "./listMcpApprovalRequests.core.js";
export {
  buildListMcpApprovalRequestsQuery,
  type ListMcpApprovalRequestsQueryData,
  prefetchListMcpApprovalRequests,
  queryKeyListMcpApprovalRequests,
};

export type ListMcpApprovalRequestsQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listRequests mcpApproval
 *
 * @remarks
 * List MCP approval requests for a project.
 */
export function useListMcpApprovalRequests(
  request?: ListMcpApprovalRequestsRequest | undefined,
  security?: ListMcpApprovalRequestsSecurity | undefined,
  options?: QueryHookOptions<
    ListMcpApprovalRequestsQueryData,
    ListMcpApprovalRequestsQueryError
  >,
): UseQueryResult<
  ListMcpApprovalRequestsQueryData,
  ListMcpApprovalRequestsQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildListMcpApprovalRequestsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listRequests mcpApproval
 *
 * @remarks
 * List MCP approval requests for a project.
 */
export function useListMcpApprovalRequestsSuspense(
  request?: ListMcpApprovalRequestsRequest | undefined,
  security?: ListMcpApprovalRequestsSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    ListMcpApprovalRequestsQueryData,
    ListMcpApprovalRequestsQueryError
  >,
): UseSuspenseQueryResult<
  ListMcpApprovalRequestsQueryData,
  ListMcpApprovalRequestsQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildListMcpApprovalRequestsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setListMcpApprovalRequestsData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      status?: string | undefined;
      limit?: number | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: ListMcpApprovalRequestsQueryData,
): ListMcpApprovalRequestsQueryData | undefined {
  const key = queryKeyListMcpApprovalRequests(...queryKeyBase);

  return client.setQueryData<ListMcpApprovalRequestsQueryData>(key, data);
}

export function invalidateListMcpApprovalRequests(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      status?: string | undefined;
      limit?: number | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "mcpApproval", "listRequests", ...queryKeyBase],
  });
}

export function invalidateAllListMcpApprovalRequests(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "mcpApproval", "listRequests"],
  });
}
